<template>
    <!-- eslint-disable-next-line vue/max-attributes-per-line -->
    <div class="row justify-content-center mx-2">
        <div class="col-md-11 mx-auto pt-3 pb-5">
            <table class="mx-auto" style="width:100%;">
                <thead>
                    <tr>
                        <th class="px-2" >
                            <input
                                type="text"
                                style="font-size:11px;width:100%; border:1px solid #3A9AF3; border-radius:5px; color:#3A9AF3;"
                                placeholder="Type in a company name and press 'Enter'"
                                v-model="filtername"
                                @change="onFilterNameChange()"
                            />
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div
            v-for="(business_directory, index) in sortedCustoms"
            :key="index"
            class="col-md-11 pt-0 mb-1 pb-3 px-2"
            id="accordion"
        >
            <div class="card w-100">
                <div class="card-header" id="headingOne">
                    <h5 class="mb-0">
                        <b-button
                            v-b-toggle="'accordion-productdetails' + index"
                            variant="light"
                        >
                            <p
                                class="text-left mb-0 font-weight-bold"
                                style="color: #3A9AF3;"
                            >    
                            
                               

                                <span>{{ business_directory.name }}</span>
                                <span  v-if="business_directory.country_presence==='KE'" style="position: absolute; right: 5%;">
                                <img src="/ressources/KENYA/640px-Flag_of_Kenya.svg.png" style="height: 40px;">
                                </span>

                                  <span  v-else-if="business_directory.country_presence==='UG'" style="position: absolute; right: 5%;">
                                <img src="ressources/UGANDA/ug-lgflag.png" style="height: 40px;">
                                </span>
                                  <span  v-else-if="business_directory.country_presence==='MA'" style="position: absolute; right: 5%;">
                                <img src="/ressources/MOROCCO/640px-Flag_of_Morocco.svg.png" style="height: 40px;">
                                </span>
                                  <span  v-else-if="business_directory.country_presence==='SE'" style="position: absolute; right: 5%;">
                                <img src="/ressources/SENEGAL/senegal.png" style="height: 40px;">
                                </span>
                                  <span  v-else-if="business_directory.country_presence==='TZ'" style="position: absolute; right: 5%;">
                                <img src="/ressources/TANZANIA/tanzania.png" style="height: 40px;">
                                </span>
                                <span  v-else-if="business_directory.country_presence==='EG'" style="position: absolute; right: 5%;">
                                <img src="/ressources/EGYPT/egypt-map.gif" style="height: 40px;">
                                </span>
                                 <span  v-else-if="business_directory.country_presence==='CI'" style="position: absolute; right: 5%;">
                                <img src="/ressources/COTEIVOIRE/drapeau-cote-divoire.png" style="height: 40px;">
                                </span>
                                <span  v-else-if="business_directory.country_presence==='ZA'" style="position: absolute; right: 5%;">
                                <img src="/ressources/SOUTHAFRICA/southafrica.png" style="height: 40px;">
                                </span>
                                 <span  v-else-if="business_directory.country_presence==='NG'" style="position: absolute; right: 5%;">
                                <img src="ressources/NIGERIA/nigeria.png" style="height: 40px;">
                                </span>
                               

                                <span  v-else style="position: absolute; right: 5%;">
                                 {{
                                    business_directory.country_presence
                                }}
                                </span>
                                
                                 


                            </p>
                        </b-button>
                    </h5>
                </div>

                <b-collapse
                    :id="'accordion-productdetails' + index"
                    class="collapse"
                    aria-labelledby="headingOne"
                    :accordion="'productdetails-accordion' + index"
                >
                    <div class="card-body">
                        <div class="text-left mx-4 mb-4">
                            <img
                                :src="
                                    '/storage/' + business_directory.logo_uuid
                                "
                                style="max-width: 200px;"
                            />
                        </div>
                        <p>
                            <strong>Sector:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.sector
                            }}</span>
                        </p>
                        <p>
                            <strong>Employees:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.employees
                            }}</span>
                        </p>
                        <p>
                            <strong>Founded in:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.year
                            }}</span>
                        </p>
                        <p style="text-align: justify!important;">
                            <strong>Introduction:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.description
                            }}</span>
                        </p>
                        <p>
                            <strong>Operates also in:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.operation
                            }}</span>
                        </p>
                        <p>
                            <strong>Office address:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.address
                            }}</span>
                        </p>
                        <p>
                            <strong>Website:</strong>
                            <span style="color: rgb(100, 100, 100);">
                                <a
                                    :href="'//' + business_directory.website"
                                    target="_blank"
                                    rel="noopener"
                                >
                                    {{ business_directory.website }}
                                </a></span
                            >
                        </p>
                        <div
                            style="border-bottom: 1px solid #ccc; padding-bottom: 5px; padding-top: 5px;"
                        ></div>
                        <div class="text-left m-4 circular-landscape">
                            <img
                                :src="
                                    '/storage/' +
                                        business_directory.contact_uuid
                                "
                            />
                        </div>
                        <p>
                            <strong>Representative:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.contact_name
                            }}</span>
                        </p>
                        <p>
                            <strong>Title:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.contact_title
                            }}</span>
                        </p>
                        <p>
                            <strong>Phone:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.contact_tel
                            }}</span>
                        </p>
                        <p>
                            <strong>Email:</strong>
                            <span style="color: rgb(100, 100, 100);">
                                <a
                                    :href="'//' + business_directory.website"
                                    target="_blank"
                                    rel="noopener"
                                    >{{ business_directory.email }}</a
                                ></span
                            >
                        </p>
                        <p>
                            <strong>Based in:</strong>
                            <span style="color: rgb(100, 100, 100);">{{
                                business_directory.city
                            }}</span>
                        </p>
                    </div>
                </b-collapse>
            </div>
            <!-- <div class="card w-100">
                <div class="card-header" id="headingOne">
                    <h5 class="mb-0">
                    <button class="btn w-100" data-bs-toggle="collapse"  :data-bs-target="'#collapse' + index" aria-expanded="true">
                        <p class="text-left mb-0 font-weight-bold" style="color: #3A9AF3;">{{ business_directory.name }}</p>
                    </button>
                    </h5>
                </div>

                <div :id="'collapse' + index" class="collapse" aria-labelledby="headingOne" >
                    <div class="card-body">
                        <div class="text-left m-4">
                            <img :src="'/storage/'+business_directory.logo_uuid" style="max-width: 100px;">
                        </div>
                        <p><strong>Sector:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.sector }}</span></p>
                        <p><strong>Employees:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.employees }}</span></p>
                        <p><strong>Year:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.year }}</span></p>
                        <p><strong>Description:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.description }}</span></p>
                        <p><strong>Operation:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.operation }}</span></p>
                        <p><strong>Address:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.address }}</span></p>
                        <p><strong>Website:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.website }}</span></p>
                        <div style="border-bottom: 1px solid #ccc; padding-bottom: 5px; padding-top: 5px;"></div>
                        <div class="text-left m-4 circular-landscape">
                            <img :src="'/storage/'+business_directory.contact_uuid">
                        </div>
                        <p><strong>Representative name:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.contact_name }}</span></p>
                        <p><strong>Representative job title:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.contact_title }}</span></p>
                        <p><strong>Representative phone:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.contact_tel }}</span></p>
                        <p><strong>Representative email:</strong> <span style="color: rgb(100, 100, 100);">{{ business_directory.email }}</span></p>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    props: ["business_directories", "token", "route"],

    data() {
        return {
            customs: [],
            filtername: ""
        };
    },

    mounted() {
        this.business_directories.forEach(business_directory => {
            this.customs.push(business_directory);
        });
    },
    computed: {
        sortedCustoms() {
            let sortedCustoms = this.customs;

            sortedCustoms = sortedCustoms.sort((a, b) => {
                let fa = a.name.toLowerCase(),
                    fb = b.name.toLowerCase();
                if (fa < fb) {
                    return -1;
                }
                if (fa > fb) {
                    return 1;
                }
                return 0;
            });

            return sortedCustoms;
        }
    },

    methods: {
        onFilterNameChange() {
            this.customs = [];
            this.business_directories.forEach(business_directory => {
                if (
                    business_directory.name
                        .toLowerCase()
                        .includes(this.filtername.toLowerCase())
                ) {
                    this.customs.push(business_directory);
                }
            });
        }
    }
};
</script>
